import {postRequest} from "../utils/http";
import {baseURL} from "../global/environment";

const base = `${baseURL}/tel_service`;
const Authorization = "Bearer a60bd62fed0cf1076e93af76114f196bd9c5a48155b2bac88afe15c49595414b";

const getHeaders = () => ({
    Authorization,
    Language: localStorage.getItem('language') === "en-US" ? "en_US" : "vi_VN"
});

export const TelService = {
    checkConsent: function (data, successCallback, failCallback) {
        const URL = `${base}/term/checkConsent`;
        return postRequest(URL, data || {}, {headers: getHeaders()}, successCallback, failCallback);
    },

    getTerms: function (data, successCallback, failCallback) {
        const URL = `${base}/term/getTerms`;
        return postRequest(URL, data || {}, {headers: getHeaders()}, successCallback, failCallback);
    },

    saveConsent: function (data, successCallback, failCallback) {
        const URL = `${base}/term/saveConsent`;
        return postRequest(URL, data || {}, {headers: getHeaders()}, successCallback, failCallback);
    },
}